import type { HousekeepingRealtimeEnvelope } from "./types.ts";

export interface HousekeepingRealtimeGateway {
  publish: (envelope: HousekeepingRealtimeEnvelope) => Promise<void> | void;
}

export class InMemoryHousekeepingRealtimeGateway implements HousekeepingRealtimeGateway {
  published: HousekeepingRealtimeEnvelope[] = [];

  publish(envelope: HousekeepingRealtimeEnvelope) {
    this.published.unshift(envelope);
  }
}
